// Indhold til bestillersiden (Kommuner og Kriminalforsorgen) – DA/EN.
// Genbruger de fem forløb fra indsatser.js; dette er ren sidetekst.

const data = {
  da: {
    nav: "Kommuner og Kriminalforsorgen",
    seoTitle: "Samarbejde med kommuner og Kriminalforsorgen | Lotusgruppen",
    seoDesc:
      "Lotusgruppen tilbyder individuelt tilrettelagte forløb med fast kontaktperson, dokumentation og tæt samarbejde omkring udsatte borgere.",
    heroBadge: "For kommunale sagsbehandlere, jobcentre, myndighedsledere og Kriminalforsorgen",
    heroTitle: "En sammenhængende indsats omkring borgere med komplekse støttebehov",
    heroSub:
      "Lotusgruppen samarbejder med kommuner, Kriminalforsorgen, behandlingssystemet og virksomheder om individuelt tilrettelagte forløb med tydelige mål, fast kontaktperson og løbende dokumentation.",
    heroPrimary: "Drøft en konkret opgave",
    heroSecondary: "Find det rette forløb",
    pdfButton: "Hent information til bestiller",

    situationsTitle: "Hvem kan indsatsen være relevant for?",
    situationsIntro: "Vi møder ofte borgere i situationer som disse:",
    situations: [
      "Borgere, der står foran eller nyligt er blevet løsladt",
      "Borgere med behov for støtte til bolig, økonomi og myndighedskontakt",
      "Borgere med ustabil døgnrytme, fremmøde eller hverdagsstruktur",
      "Borgere, der har vanskeligt ved at fastholde behandling eller aftaler",
      "Borgere, der skal nærme sig praktik, uddannelse eller beskæftigelse",
      "Borgere, der er begyndt i aktivitet, men risikerer fravær eller frafald",
      "Borgere, hvor støttebehov og den relevante indsats endnu er uklare",
    ],
    situationsNote:
      "Indsatsen tilrettelægges ud fra den enkelte borgers aktuelle situation, egne mål, ressourcer og støttebehov.",

    processTitle: "Sådan etableres et samarbejde",
    processSteps: [
      { title: "Indledende henvendelse", text: "Bestiller kontakter Lotusgruppen med en overordnet beskrivelse af opgaven uden at indsende følsomme personoplysninger gennem hjemmesiden." },
      { title: "Faglig dialog", text: "Lotusgruppen og bestiller drøfter borgerens situation, formålet med indsatsen, forventet støtteintensitet og relevante samarbejdspartnere." },
      { title: "Forslag til indsats", text: "Lotusgruppen anbefaler et forløb eller udarbejder et konkret forslag til en individuelt tilrettelagt indsats." },
      { title: "Aftale og opstart", text: "Mål, rammer, kontaktform, dokumentation, mødefrekvens og ansvarsfordeling aftales med bestiller." },
      { title: "Gennemførelse og opfølgning", text: "Borgeren får en fast kontaktperson. Bestiller modtager aftalt status og orienteres hurtigt ved væsentlige udfordringer." },
      { title: "Evaluering og næste skridt", text: "Indsatsen evalueres sammen med borgeren, bestiller og relevante samarbejdspartnere. Der tages stilling til afslutning, forlængelse eller overgang til en anden indsats." },
    ],
    processCta: "Indled en faglig dialog",

    deliverablesTitle: "En tydelig leverance – ikke blot løbende kontakt",
    deliverablesIntro: "Leverancen fastlægges i den konkrete aftale, men kan typisk omfatte:",
    deliverables: [
      "Fast kontaktperson",
      "Beskrivelse af mål og delmål",
      "Individuel indsats- eller udviklingsplan",
      "Dokumentation af gennemførte aktiviteter",
      "Løbende progressionsstatus",
      "Månedlig eller aftalt status til bestiller",
      "Deltagelse i tværfaglige møder",
      "Hurtig orientering ved væsentligt fravær, konflikt eller brud i indsatsen",
      "Koordinering med relevante samarbejdspartnere efter aftale og samtykke",
      "Afsluttende status med anbefaling til næste skridt",
    ],
    deliverablesNote:
      "Dokumentationens omfang og frekvens aftales med bestiller og tilpasses forløbets formål og intensitet.",

    progressionTitle: "Dokumentation og progression",
    progressionIntro: "Resultatmål vælges individuelt – ikke alle er relevante i alle forløb. Mulige progressionsområder:",
    progressionAreas: [
      "Fremmøde og overholdelse af aftaler",
      "Bolig og praktisk stabilitet",
      "Økonomi, post og myndighedskontakt",
      "Døgnrytme og hverdagsstruktur",
      "Behandlingskontakt",
      "Konflikthåndtering",
      "Kommunikation og samarbejde",
      "Praktik, uddannelse eller beskæftigelse",
      "Fastholdelse i aktivitet",
      "Borgerens egne mål og oplevede udvikling",
    ],
    progressionNote:
      "Lotusgruppen dokumenterer den indsats, der er gennemført, den observerede progression og de udfordringer, der fortsat kræver opmærksomhed. Vi garanterer ikke et bestemt slutresultat, men vi står på mål for indsats, tilgængelighed, opfølgning og dokumentation.",

    collabTitle: "Samarbejdet omkring borgeren",
    collabIntro: "Relevante aktører kan efter opgave og samtykke være:",
    collaborators: [
      "Kommunal sagsbehandler", "Jobcenter", "Kriminalforsorgen",
      "Behandlingspsykiatri eller øvrigt behandlingssystem", "Misbrugsbehandling",
      "Uddannelsesinstitution", "Praktiksted eller arbejdsplads", "Boligaktører",
      "Familie eller andet relevant netværk",
    ],
    collabNote:
      "Kontakt og informationsdeling med andre aktører sker inden for den aftalte opgave og på det nødvendige retlige og samtykkemæssige grundlag.",

    businessTitle: "Virksomhedssamarbejde og beskæftigelse",
    businessIntro: "Når virksomhedsrettet støtte er relevant, kan indsatsen omfatte:",
    business: [
      "Afklaring af ressourcer og hensyn",
      "Match med relevant virksomhed eller aktivitet",
      "Forberedelse før opstart",
      "Tydelige arbejdsopgaver",
      "Gradvis optrapning af timer og ansvar",
      "Kontakt til virksomheden",
      "Hurtig indsats ved fravær eller konflikt",
      "Støtte til overgang fra praktik til ordinære timer, uddannelse eller ansættelse, når det er realistisk",
    ],
    businessNote:
      "Virksomhedspraktik eller beskæftigelse etableres ikke som en garanti, men som et mål, der arbejdes hen imod, når borgerens situation og den konkrete opgave gør det relevant.",

    faqTitle: "Faglig FAQ",
    faq: [
      { q: "Hvem kan henvise eller bestille et forløb?", a: "Lotusgruppen indgår dialog med kommunale afdelinger, jobcentre, Kriminalforsorgen og andre relevante offentlige bestillere. Den konkrete aftale afhænger af opgaven og bevillingsgrundlaget." },
      { q: "Kan et forløb tilpasses individuelt?", a: "Ja. De fem beskrevne forløb fungerer som tydelige rammer, men kontaktintensitet, mål, samarbejdsflader og dokumentation aftales konkret." },
      { q: "Hvordan vælger vi det rette forløb?", a: "Bestiller kan bruge forløbsvælgeren som en vejledende hjælp eller kontakte Lotusgruppen for en indledende faglig vurdering. Ved uklart støttebehov kan Lotus Afklaring være relevant." },
      { q: "Hvor hurtigt kan et forløb starte?", a: "Det afhænger af opgaven, støtteintensiteten, geografi og den nødvendige forberedelse. Lotusgruppen giver en konkret tilbagemelding efter den første dialog." },
      { q: "Modtager bestiller skriftlig dokumentation?", a: "Ja, når det indgår i aftalen. Dokumentationens form og frekvens fastlægges i forbindelse med bestillingen." },
      { q: "Kan Lotusgruppen samarbejde med en arbejdsplads?", a: "Ja, når virksomhedsrettet støtte er relevant og indgår i opgaven. Kontakten kan blandt andet omfatte opstart, forventningsafstemning og hurtig indsats ved udfordringer." },
      { q: "Garanterer Lotusgruppen, at borgeren kommer i arbejde?", a: "Nej. Lotusgruppen kan garantere den aftalte indsats, tilgængelighed, dokumentation og opfølgning – ikke et bestemt resultat." },
      { q: "Kan vi sende oplysninger om en konkret borger gennem kontaktformularen?", a: "Kontaktformularen må ikke bruges til CPR-nummer, helbredsoplysninger, domsoplysninger eller andre følsomme personoplysninger. Den konkrete sag drøftes efterfølgende gennem en aftalt og sikker kommunikationsform." },
      { q: "Kan Lotusgruppen deltage i statusmøder?", a: "Ja, når det er aftalt som en del af indsatsen." },
      { q: "Hvad koster et forløb?", a: "Prisen fastsættes efter støttebehov, indsatsintensitet, varighed, geografi og den konkrete bestilling. Kontakt Lotusgruppen for en individuel vurdering." },
    ],

    guaranteesTitle: "Hvad Lotusgruppen garanterer",
    canTitle: "Lotusgruppen kan stå på mål for",
    can: [
      "En tydeligt beskrevet indsats", "Fast kontaktperson", "Aftalt kontaktintensitet",
      "Høj tilgængelighed inden for den aftalte ramme", "Løbende opfølgning", "Aftalt dokumentation",
      "Hurtig reaktion ved væsentlige udfordringer", "Samarbejde med relevante aktører",
      "Ærlig kommunikation om progression og barrierer",
    ],
    cannotTitle: "Lotusgruppen garanterer ikke",
    cannot: [
      "Kriminalitetsfrihed", "Ordinær beskæftigelse", "Bestemte behandlingsresultater",
      "At alle mål nås inden for en bestemt periode",
      "At andre myndigheder eller samarbejdspartnere træffer bestemte afgørelser",
    ],

    forloebTitle: "De fem forløb",
    forloebIntro: "Tydelige rammer, der tilpasses den konkrete opgave.",
    seeForloeb: "Se forløbet",

    contactTitle: "Har du en konkret borger eller opgave, du ønsker at drøfte?",
    contactSub:
      "Send en overordnet henvendelse uden følsomme personoplysninger. Vi kontakter dig for en indledende faglig dialog om behov, muligheder og næste skridt.",
    contactPrimary: "Drøft en konkret opgave",
    contactFinder: "Find det rette forløb",
    contactCall: "Ring til Lotusgruppen",
  },

  en: {
    nav: "Municipalities and the Probation Service",
    seoTitle: "Municipal and Probation Service Partnerships | Lotusgruppen",
    seoDesc:
      "Lotusgruppen provides structured support pathways, dedicated contacts, progress documentation and coordinated professional collaboration.",
    heroBadge: "For municipal caseworkers, job centres, authority managers and the Probation Service",
    heroTitle: "A coherent effort around citizens with complex support needs",
    heroSub:
      "Lotusgruppen collaborates with municipalities, the Probation Service, the treatment system and companies on individually designed pathways with clear goals, a fixed contact person and ongoing documentation.",
    heroPrimary: "Discuss a specific case",
    heroSecondary: "Find the right pathway",
    pdfButton: "Download information for commissioners",

    situationsTitle: "Who can the effort be relevant for?",
    situationsIntro: "We often meet citizens in situations such as these:",
    situations: [
      "Citizens facing or recently released from prison",
      "Citizens needing support with housing, finances and authority contact",
      "Citizens with an unstable daily rhythm, attendance or everyday structure",
      "Citizens who find it hard to maintain treatment or appointments",
      "Citizens moving towards a placement, education or employment",
      "Citizens who have started an activity but risk absence or drop-out",
      "Citizens where support needs and the relevant effort are still unclear",
    ],
    situationsNote:
      "The effort is designed based on the individual citizen's current situation, own goals, resources and support needs.",

    processTitle: "How a collaboration is established",
    processSteps: [
      { title: "Initial enquiry", text: "The commissioner contacts Lotusgruppen with an overall description of the task, without submitting sensitive personal data through the website." },
      { title: "Professional dialogue", text: "Lotusgruppen and the commissioner discuss the citizen's situation, the purpose of the effort, expected support intensity and relevant partners." },
      { title: "Proposed effort", text: "Lotusgruppen recommends a pathway or prepares a concrete proposal for an individually designed effort." },
      { title: "Agreement and start-up", text: "Goals, framework, contact form, documentation, meeting frequency and responsibilities are agreed with the commissioner." },
      { title: "Delivery and follow-up", text: "The citizen gets a fixed contact person. The commissioner receives the agreed status and is informed quickly of significant challenges." },
      { title: "Evaluation and next steps", text: "The effort is evaluated together with the citizen, commissioner and relevant partners. A decision is made on conclusion, extension or transition to another effort." },
    ],
    processCta: "Start a professional dialogue",

    deliverablesTitle: "A clear deliverable – not just ongoing contact",
    deliverablesIntro: "The deliverable is set in the specific agreement, but can typically include:",
    deliverables: [
      "A fixed contact person", "Description of goals and sub-goals", "An individual effort or development plan",
      "Documentation of completed activities", "Ongoing progress status", "Monthly or agreed status to the commissioner",
      "Participation in interdisciplinary meetings", "Fast notification of significant absence, conflict or breakdown",
      "Coordination with relevant partners by agreement and consent", "Closing status with a recommendation for next steps",
    ],
    deliverablesNote:
      "The scope and frequency of documentation are agreed with the commissioner and adapted to the purpose and intensity of the pathway.",

    progressionTitle: "Documentation and progression",
    progressionIntro: "Result goals are chosen individually – not all are relevant in every pathway. Possible progression areas:",
    progressionAreas: [
      "Attendance and keeping appointments", "Housing and practical stability", "Finances, mail and authority contact",
      "Daily rhythm and everyday structure", "Treatment contact", "Conflict management",
      "Communication and cooperation", "Placement, education or employment", "Retention in activity",
      "The citizen's own goals and perceived development",
    ],
    progressionNote:
      "Lotusgruppen documents the effort carried out, the observed progression and the challenges that still require attention. We do not guarantee a specific end result, but we stand behind our effort, availability, follow-up and documentation.",

    collabTitle: "Collaboration around the citizen",
    collabIntro: "Depending on the task and consent, relevant actors may include:",
    collaborators: [
      "Municipal caseworker", "Job centre", "The Probation Service",
      "Psychiatric or other treatment services", "Addiction treatment",
      "Educational institution", "Placement or workplace", "Housing actors",
      "Family or other relevant network",
    ],
    collabNote:
      "Contact and information sharing with other actors takes place within the agreed task and on the necessary legal and consent basis.",

    businessTitle: "Company collaboration and employment",
    businessIntro: "When company-oriented support is relevant, the effort can include:",
    business: [
      "Clarifying resources and considerations", "Matching with a relevant company or activity",
      "Preparation before start-up", "Clear work tasks", "Gradual increase in hours and responsibility",
      "Contact with the company", "Fast action in case of absence or conflict",
      "Support for the transition from placement to ordinary hours, education or employment, when realistic",
    ],
    businessNote:
      "A work placement or employment is not established as a guarantee, but as a goal worked towards when the citizen's situation and the specific task make it relevant.",

    faqTitle: "Professional FAQ",
    faq: [
      { q: "Who can refer or order a pathway?", a: "Lotusgruppen enters into dialogue with municipal departments, job centres, the Probation Service and other relevant public commissioners. The specific agreement depends on the task and funding basis." },
      { q: "Can a pathway be individually adapted?", a: "Yes. The five described pathways act as clear frameworks, but contact intensity, goals, collaboration and documentation are agreed specifically." },
      { q: "How do we choose the right pathway?", a: "The commissioner can use the pathway finder as a guiding aid or contact Lotusgruppen for an initial professional assessment. If the support need is unclear, Lotus Assessment may be relevant." },
      { q: "How quickly can a pathway start?", a: "It depends on the task, support intensity, geography and the necessary preparation. Lotusgruppen gives concrete feedback after the first dialogue." },
      { q: "Does the commissioner receive written documentation?", a: "Yes, when it is part of the agreement. The form and frequency of documentation are set in connection with the order." },
      { q: "Can Lotusgruppen collaborate with a workplace?", a: "Yes, when company-oriented support is relevant and part of the task. The contact can include start-up, alignment of expectations and fast action on challenges." },
      { q: "Does Lotusgruppen guarantee that the citizen gets a job?", a: "No. Lotusgruppen can guarantee the agreed effort, availability, documentation and follow-up – not a specific result." },
      { q: "Can we send information about a specific citizen through the contact form?", a: "The contact form must not be used for CPR numbers, health data, sentence data or other sensitive personal data. The specific case is discussed afterwards through an agreed, secure form of communication." },
      { q: "Can Lotusgruppen take part in status meetings?", a: "Yes, when agreed as part of the effort." },
      { q: "What does a pathway cost?", a: "The price is set according to support needs, intensity, duration, geography and the specific order. Contact Lotusgruppen for an individual assessment." },
    ],

    guaranteesTitle: "What Lotusgruppen guarantees",
    canTitle: "Lotusgruppen stands behind",
    can: [
      "A clearly described effort", "A fixed contact person", "The agreed contact intensity",
      "High availability within the agreed framework", "Ongoing follow-up", "Agreed documentation",
      "Fast response to significant challenges", "Cooperation with relevant actors",
      "Honest communication about progression and barriers",
    ],
    cannotTitle: "Lotusgruppen does not guarantee",
    cannot: [
      "Freedom from crime", "Ordinary employment", "Specific treatment results",
      "That all goals are reached within a specific period",
      "That other authorities or partners make specific decisions",
    ],

    forloebTitle: "The five pathways",
    forloebIntro: "Clear frameworks adapted to the specific task.",
    seeForloeb: "View pathway",

    contactTitle: "Do you have a specific citizen or task you'd like to discuss?",
    contactSub:
      "Send an overall enquiry without sensitive personal data. We'll contact you for an initial professional dialogue about needs, options and next steps.",
    contactPrimary: "Discuss a specific case",
    contactFinder: "Find the right pathway",
    contactCall: "Call Lotusgruppen",
  },
};

export const getKommuner = (lang) => data[lang] || data.da;
